import { useCallback, useState } from 'react';
import { ClientService } from '../../services/client/clientService';

/*----------------------------------------------------------------------------------------
* EN: Hook to manage clients fetching and transformation logic.
* ES: Hook para gestionar la lógica de obtención y transformación de clientes.
----------------------------------------------------------------------------------------*/

const useClients = (initialFilters = {}) => {

    const [data, setData] = useState<any[]>([]);
    const filters = {
        limit: 200,
        filter_filters: { ...initialFilters }
    };

    const fetchClients = useCallback(async (f: any) => {
        const newFilters = { ...filters, filter_filters: { ...filters.filter_filters, ...f } };
        try {
            const response = await (new ClientService()).listClients(newFilters);
            const fetchedData = response.getResponseData()?.data;

            if (fetchedData && fetchedData?.data) {
                const mappedData = fetchedData.data?.map((data: { id: string; companyName: string; cifNif: string; }) => ({
                    value: data.id,
                    label: data.companyName + ' (' + data.cifNif + ')',
                }));
                setData(mappedData);
                return mappedData;
            }
        } catch (error) {
            console.log('Error fetching clients:', error);
        }
    }, []);

    const getClientsList = () => {
        return data;
    };

    return { fetchClients, getClientsList };
}

export default useClients;